import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { http, errMsg } from "../../lib/api";
import { useAuth } from "../../lib/auth";

const C0 = { nombre: "", linea: "captacion", canal: "web", desde: "", hasta: "", presupuesto: "", utm: "" };
const inp = "w-full min-w-0 rounded-xl border border-[#E2DDD5] bg-white px-3 py-2 text-sm";

const Nueva = ({ onSaved }) => {
  const [f, setF] = useState(C0);
  const s = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = () => http.post("/demanda/campanas", { ...f, presupuesto: f.presupuesto ? Number(f.presupuesto) : null }).then(() => { toast.success("Campaña creada"); setF(C0); onSaved(); }).catch((e) => toast.error(errMsg(e)));
  return (
    <div className="grid gap-2 rounded-2xl border border-[#E2DDD5] bg-white p-4 sm:grid-cols-4" data-testid="campana-nueva">
      <input className={`${inp} sm:col-span-2`} placeholder="Nombre" value={f.nombre} onChange={s("nombre")} data-testid="campana-nombre" />
      <select className={inp} value={f.linea} onChange={s("linea")} data-testid="campana-linea"><option value="credito">Crédito</option><option value="captacion">Captación</option><option value="ambas">Ambas</option></select>
      <select className={inp} value={f.canal} onChange={s("canal")} data-testid="campana-canal">{["web", "referenciador", "evento", "redes", "email", "otro"].map((c) => <option key={c}>{c}</option>)}</select>
      <input className={inp} type="date" value={f.desde} onChange={s("desde")} data-testid="campana-desde" />
      <input className={inp} type="date" value={f.hasta} onChange={s("hasta")} data-testid="campana-hasta" />
      <input className={inp} placeholder="Presupuesto (opcional)" type="number" value={f.presupuesto} onChange={s("presupuesto")} data-testid="campana-presupuesto" />
      <input className={inp} placeholder="Código UTM (p. ej. expo-pymes-26)" value={f.utm} onChange={s("utm")} data-testid="campana-utm" />
      <button onClick={save} data-testid="campana-guardar" className="inline-flex items-center justify-center gap-1 rounded-full bg-[#0B2545] px-4 py-2 text-xs font-semibold text-white hover:bg-[#E8643C] sm:col-span-4"><Plus size={14} />Crear campaña</button>
    </div>
  );
};

export const Campanas = () => {
  const { user } = useAuth();
  const [sp] = useSearchParams();
  const [items, setItems] = useState([]);
  const load = () => http.get("/demanda/campanas").then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);
  const adm = ["master", "admin"].includes(user?.template) || user?.role === "director";
  return (
    <section className="space-y-4" data-testid="demanda-campanas">
      <div><h1 className="font-serif-display text-3xl font-bold text-[#0B2545]">Campañas</h1>
        <p className="mt-1 text-sm text-[#5C5850]">Liga cada campaña con su código UTM: <code className="rounded bg-white px-1">?utm_campaign=código</code> en la liga pública. Atribución por primer contacto; la etiqueta manual prevalece.</p></div>
      {adm && <Nueva onSaved={load} />}
      <ul className="grid gap-3 md:grid-cols-2">{items.map((c) => (
        <li key={c.id} className={`rounded-2xl border bg-white p-4 ${sp.get("id") === c.id ? "border-[#E8643C] ring-2 ring-[#E8643C]/30" : "border-[#E2DDD5]"}`} data-testid={`campana-${c.utm}`}>
          <div className="text-sm font-bold text-[#0B2545]">{c.nombre}</div>
          <div className="mt-1 flex flex-wrap gap-2 text-[11px] text-[#5C5850]"><span className="rounded-full bg-[#F2F0EC] px-2">{c.linea}</span><span className="rounded-full bg-[#F2F0EC] px-2">{c.canal}</span>
            <span>{c.desde} → {c.hasta}</span><span className="font-mono">utm: {c.utm}</span>{c.tasa_serie && <span className="rounded-full bg-[#E8643C]/10 px-2 text-[#B4532A]">Tabla de tasas {c.tasa_serie}</span>}</div>
          {c.presupuesto != null && <div className="mt-1 text-xs">Presupuesto: ${Number(c.presupuesto).toLocaleString("es-MX")}</div>}
        </li>))}</ul>
    </section>
  );
};
